import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { getEnvConfig } from '@configs/env';
import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';
import { CheckIcon } from '@icons/CheckIcon';
import * as S from './TenantRequestDoneStyles';

export const TenantRequestDone = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { providerDomain } = useParams<{ providerDomain?: string }>();
  const { ONLY_USE_LOGIN_PAGE } = getEnvConfig();

  const enabledOnlyUseLoginPage = ONLY_USE_LOGIN_PAGE === 'true';

  const getStoreLink = () => {
    if (providerDomain) {
      return { href: `/stores/${providerDomain}`, label: t('Ad_Cart_07') };
    }
    if (enabledOnlyUseLoginPage) {
      return { href: '/login', label: t('Ad_Cart_16') };
    }
    return { href: '/store', label: t('Ad_Cart_07') };
  };

  const { href, label } = getStoreLink();

  return (
    <S.Conatiner>
      <S.IconWrapper>
        <CheckIcon width={32} height={32} color={colors['ic-white']} />
      </S.IconWrapper>

      <Typography variant="headline4" marginBottom="20px">
        {t('Service_Request_11')}
      </Typography>

      <S.Content variant="body1">
        {t('Tenant_Request_Done_01')}👏
        <br />
        <Trans i18nKey="Tenant_Request_Done_02" components={{ 1: <strong /> }} />
      </S.Content>

      <S.GoToStore href={href}>{label}</S.GoToStore>
    </S.Conatiner>
  );
};
